import React from 'react';

import { Result } from 'antd';

import { TimeLineRow } from '../../shipments/components/TimeLineRow';
import { boxLifecycle } from '../models/boxLifecycle';

export const BoxLifecycleHistory = ({ lifecycleStatuses, lpUi, onRefetch }) => {
  const noData = lifecycleStatuses.length === 0;

  if (noData) {
    return <Result status="info" title="No lifecycle statuses." />;
  }

  // Find the index of the first non-disabled item
  const firstNonDisabledIndex = lifecycleStatuses.findIndex(
    (item: any) => !item.disabled
  );

  const getDeletableStatus = (index: number) => {
    const isLastItem = index === lifecycleStatuses.length - 1;
    const isFirstNonDisabled = index === firstNonDisabledIndex;

    return isFirstNonDisabled && !isLastItem;
  };

  return (
    <div data-testid="lifecycle-timelines">
      {lifecycleStatuses.map((item: boxLifecycle, index: number) => (
        <TimeLineRow
          key={item.id}
          timeLineEvent={item}
          index={index}
          isDeletable={getDeletableStatus(index)}
          lpUi={lpUi}
          onRefetch={onRefetch}
        />
      ))}
    </div>
  );
};
